import { render } from "./ContactInformations.vue?vue&type=template&id=29c1b9b6&scoped=true"
import script from "./ContactInformations.vue?vue&type=script&lang=js"
export * from "./ContactInformations.vue?vue&type=script&lang=js"

import "./ContactInformations.vue?vue&type=style&index=0&id=29c1b9b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c1b9b6"]])

export default __exports__